<template>
  <wptv-modal-onei
    ref="implicitTestsModal"
    :close-icon="true"
    :no-cancel="true"
    :frozen="true"
    :feedback="true"
    theme="warning"
    @closed="$emit('closed')">
    <div
      v-if="code"
      slot="title">
      {{ $t(`modals.implicitTests.${code}.title`) }}
    </div>

    <div
      v-if="code"
      slot="content">
      <p v-html="$t(`modals.implicitTests.${code}.content`)" />
      <p>
        <a
          v-tealium:click="{
            track_page: 'toutes_pages',
            track_zone: 'test_auto',
            track_nom: 'popin',
            track_type: 'clic-assist_conf',
            track_detail: 'clic-assist_conf-popin-test_auto-toutes_pages'
          }"
          :href="$t(`modals.implicitTests.${code}.link.to`)"
          data-wptv="test_auto-popin">
          {{ $t(`modals.implicitTests.${code}.link.label`) }}
        </a>
      </p>
    </div>
    <div slot="buttons">
      <span class="dont-show-again-check">
        <input
          id="dsa-check"
          v-model="dsa"
          type="checkbox">
        <label for="dsa-check">
          {{ $t('modals.implicitTests.dsa') }}
        </label>
      </span>
      <wptv-button
        :aria-label="$t('modals.implicitTests.button_mobile_telecharger_application')"
        type="wired"
        background="white"
        @click.native="manageCloseButtonClick()">
        {{ $t('modals.implicitTests.acknowledgeButton') }}
      </wptv-button>
    </div>
  </wptv-modal-onei>
</template>

<script>
import { WptvModalOnei } from '@wptv/components/ui/modalOnei'
import { WptvButton } from '@wptv/components/ui/button'
import _get from 'lodash/get'
import { mapGetters } from 'vuex'

export default {
  name: 'VodImplicitTests',
  components: { WptvModalOnei, WptvButton },
  data () {
    return {
      code: null,
      dsa: false
    }
  },
  computed: {
    ...mapGetters({
      configTests: 'checkups/getConfigTests'
    })
  },
  mounted () {
    this.code = _get(this.configTests, 'capacity.code')
    this.$store.dispatch('errors/setGenericError', { error: { errorCode: this.code } })

    this.$refs.implicitTestsModal.open()
    this.sendStats({
      page: 'toutes_pages',
      zone: 'test_auto',
      area: 'popin',
      type: 'affichage'
    })
  },
  methods: {
    manageCloseButtonClick () {
      if (this.dsa) {
        localStorage.setItem('DSAChecked', true)
      }
      this.$refs.implicitTestsModal.close()
      this.sendStats({
        page: 'toutes_pages',
        zone: 'test_auto',
        area: 'popin',
        type: 'fermer'
      })
    }
  }
}
</script>

<style lang="scss" scoped>
  a {
    text-decoration: underline;
    cursor: pointer;
  }

  .dont-show-again-check {
    input {
      vertical-align: middle;
    }

    label {
      padding-left: 5px;
      margin-right: 20px;
      font-size: 1rem;
      font-weight: normal;
      vertical-align: middle;
    }
  }
</style>
